<template>
  <!-- deviceClass 设备分类-->
  <div class="energy-flow">
    <div class="con">
      <div class="tree-left">
        <div class="search">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
        </div>
        <div class="btns">
          <el-button type="primary" size="mini" @click="popupFn('add')">新增</el-button>
          <el-button type="primary" size="mini" @click="popupFn('eait')" :disabled="!unitItem.id">修改</el-button>
          <el-button type="danger" size="mini" @click="delFun" :disabled="!unitItem.id" class="del-btn">删除</el-button>
        </div>
        <div class="scroll" style="width:100%;height:93%">
          <el-scrollbar style="height:95%;width: 100%;">
            <el-tree :data="leftData" ref="leftTree" @node-click="leftTreeClick" highlight-current
              :expand-on-click-node="true" node-key="id" :filter-node-method="filterNode"
              :default-expanded-keys="defaultExpanded" :current-node-key='defaultDevice'>
              <span class="custom-tree-node" slot-scope="{node,data}" style="display: flex;align-items: center;">
                <img src="../../../public/static/image/elTree/group.png" style="margin-right: 2px;" />
                <span style="padding-left: 5px;"> {{data.deviceClassificationName}}</span>
              </span>
            </el-tree>
          </el-scrollbar>
        </div>

      </div>
      <div class="content">
        <div style="display: flex;">
          <div class="mytable">
            <el-table ref="multipleTable" :data="tableData" stripe tooltip-effect="dark" style="width: 100%"
              :max-height="heights" border @selection-change="handleSelectionChange">
              <template slot="empty">
                <span class="noData">
                  <img src="../../assets/noData.png" alt="暂无数据">
                  <span class="text">暂无数据</span>
                </span>
              </template>
              <el-table-column type="selection" width="44" align="center">
              </el-table-column>
              <el-table-column width="90" align="center" label="序号">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="设备号" width="180">
                <template slot-scope="scope">{{ scope.row.virtualDeviceNo }}</template>
              </el-table-column>
              <el-table-column prop="name" label="设备名称">
              </el-table-column>
            </el-table>
          </div>
          <div class="conten-btns">
            <div class="left-add" @click="device_Add">添加<img src="../../assets/left.png" alt=""></div>
            <div class="del-btn-transfer" @click="device_Del">移除<img src="../../assets/right.png" alt=""></div>
          </div>
        </div>
      </div>
      <div class="tree-right">
        <div class="search">
          <el-input placeholder="输入关键字进行过滤" v-model="filterTextRight"></el-input>
        </div>
        <div class="scroll" style="width:100%;height:93%">
          <el-scrollbar style="height:100%;width: 100%;">
            <el-tree :data="rightData" show-checkbox node-key="num" :props="defaultProps" @check="currentChecked"
              :filter-node-method="filterNodeRight" ref="tree">
              <span class="custom-tree-node" slot-scope="{node}">
                <img src="../../../public/static/image/elTree/1.9.png"
                  v-if="node.data.Content.Category=='Organization'" />
                <img src="../../../public/static/image/elTree/2.1.png" v-else />
                <span style="padding-left: 5px;">{{node.data.Content.Name}}</span>
              </span>
            </el-tree>
          </el-scrollbar>
        </div>

      </div>
    </div>

    <!-- 新增修改 -->
    <el-dialog v-dialogDrag :title="dialogStatus" :close-on-click-modal='false' :visible.sync="dialogVisible"
      width="22%" center class="unify-dialog">
      <div style="display: flex;">
        <el-form :model="temp" ref="temp" :rules="rules" style="width: 95%;height: 150px;padding-top: 10px;"
          label-width="40px">
          <el-form-item label="名称：:" prop="deviceClassificationName">
            <el-input v-model="temp.deviceClassificationName" style=""></el-input>
          </el-form-item>
          <el-form-item label="设备分类：" prop="deviceTypeId">
            <el-select v-model="temp.deviceTypeId" placeholder="请选择类型">
              <el-option v-for="(e,i) in selectData" :key="i" :label="e.deviceTypeName" :value="e.id" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="determine_Fn(dialogStatus)">确 定
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>

  import {getReadDeviceTree} from "../../api/abbNewApi";
  import {findModelTree,saveDissipation,updateDissipation,deleteDissipation,dissipaFinDevice,dissipationSave,dissipationRemove} from "../../api/dissipation";
  // import elRadioTree from '@/components/module/tree/elRadioTree.vue'
  import request from "@/api/http.js";
  export default {
    data () {
      return {
        heights: document.getElementById('app').clientHeight-140,
        loading: false,
        dialogStatus: "新增",//弹窗类型
        radio: "能流分析",//单选框
        selectData: [],
        leftData: [],//左边树形结构数据
        rightData: [],//右边树形结构树形
        defaultProps: {
          children: 'ChildDatas',
          label: 'Content.Name'
        },
        filterText: '',
        filterTextRight: "",
        tableData: [],
        multipleSelection: [],
        rules: {
          code: [
            {required: true,message: '请输入编号',trigger: 'blur'}
          ],
          deviceClassificationName: [
            {required: true,message: '请输入名称',trigger: 'blur'}
          ],
          modelType: [
            {required: true,message: '请输入类型',trigger: 'blur'}
          ],
        },
        temp: {
          modelName: "",
          modelType: "",
        },
        dialogVisible: false,
        unitItem: {},
        tag: 1,//判断点击的是单位/能流图/节点
        nodeItem: [],//节点
        checkedNodes: [],
        halfCheckedNodes: null,
        nowNode: "",
        defaultExpanded: [],
        defaultDevice: "",
        firstItem: "",
      }
    },
    watch: {
      'temp.deviceTypeId': function(val) {
        if(val==''||!val) {
          this.temp.deviceTypeId=''
          return
        }
        // deviceTypeName
        this.selectData.map(v => {
          if(val==v.id) {
            this.temp.deviceTypeName=v.deviceTypeName||this.temp.deviceClassificationName;
          }
        })

      },
      filterText (val) {
        this.$refs.leftTree.filter(val);
      },
      filterTextRight (val) {
        this.$refs.tree.filter(val);
      },
      unitId () {
        this.findUnitInfoFun()
      }

    },
    computed: {
      unitId () {
        return this.$store.unitStore.state.nowUnit
      }
    },
    mounted () {
      var id=this.unitId.id;
      request({url: "/deviceClassification/getDeviceTypeAll",method: "get"}).then(res => {
        if(res.code==200) {
          this.selectData=res.data;
        }
      })
      this.findUnitInfoFun()
      var num=0
      getReadDeviceTree().then(res => {
        // console.log("设备列表",res);
        var recursiveFunction=function() {
          const getStr=function(list) {
            list.forEach(function(row) {
              if(row.ChildDatas.length!=0) {
                row['num']=num++
                getStr(row.ChildDatas)
              } else {
                row['num']=num++
                row['disabled']=false
                // str += row.Content.Name + ";"
                // row.ChildDatas = row.Content.groups
              }
            })
          }
          getStr(res.data)
        }
        recursiveFunction()
        this.rightData=res.data;

      })
    },
    beforeDestroy () {
      this.nodeItem=[]
    },
    methods: {
      //左边树形结构筛选
      filterNode (value,data) {

        if(!value) return true;
        return data.deviceClassificationName.indexOf(value)!==-1;
      },
      //右边树形结构筛选
      filterNodeRight (value,data) {
        if(!value) return true;
        return data.Content.Name.indexOf(value)!==-1;
      },
      //表格全选反选
      toggleSelection (rows) {
        if(rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      handleSelectionChange (val) {
        this.multipleSelection=val;
      },
      //左边树形结构数据
      findUnitInfoFun () {
        var params={
          unitId: this.unitId.id
        }
        request({url: "/deviceClassification/getAllByUnitId",method: "get",params}).then(res => {
          console.log(res,'设备分类->根据单位Id获取设备分类');
          var d=res.data[0];
          if(res.code==200) {
            this.leftData=res.data
          }
        })
      },
      //左边数据结构点击
      leftTreeClick (item) {
        this.unitItem=item;
        this.getDeviceList(item)
      },
      //获取能流图列表
      getDeviceList (v) {
        var params={
          id: v.id,
          pageIndex: 1,
          pageSize: 10,
        }
        request({url: "/deviceClassification/findDevices",method: "get",params}).then(res => {
          if(res.code==200) {
            this.tableData=res.data;
            var a=this.rightData;
            var recursiveFunction=function() {
              const getStr=function(list) {
                list.forEach(function(row) {
                  if(row.ChildDatas.length!=0) {
                    getStr(row.ChildDatas)
                  } else {
                    row.disabled=false
                    res.data.forEach(item => {
                      if(row.Content.Id==item.virtualDeviceNo) {
                        row.disabled=true
                      }
                    })

                  }
                })
              }
              getStr(a)
            }
            recursiveFunction()

          }
        })
      },
      //弹窗
      popupFn (type) {
        var params={
          unitId: this.unitId.id
        }

        this.dialogVisible=true
        if(type=='add') {
          this.dialogStatus="新增";
          this.temp={
            deviceClassificationName: '',
            deviceTypeId: '',
            unitId: this.unitId.id
          }




        } else if(type=='eait') {
          this.dialogStatus="修改"
          this.temp=Object.assign({},this.unitItem)

        }
      },
      //添加成功提示
      addSuccess (type) {
        if(type=='新增') {
          this.$message({type: 'success',message: '添加成功!'});
        } else {
          this.$message({type: 'success',message: '修改成功!'});
        }
        this.findUnitInfoFun()
        this.temp.modelName=""
        this.temp.modelType=""
        this.dialogVisible=false
      },
      //新增修改
      determine_Fn (type) {
        this.$refs['temp'].validate(valid => {
          if(valid) {
            if(type=='新增') {
              //新增模型 
              var data=this.temp;
              request({url: "/deviceClassification/save",method: "post",data}).then(res => {
                if(res.code==200) {
                  this.addSuccess(type)
                } else {
                  res.message? this.$message.error(res.message):this.$message.error('添加失败')
                }
              })
            } else if(type=='修改') {
              var data=this.temp;
              data.uid=data.id;
              request({url: "/deviceClassification/save",method: "post",data}).then(res => {
                if(res.code==200) {
                  this.addSuccess(type)
                } else {
                  res.message? this.$message.error(res.message):this.$message.error('修改失败')
                }
              })
              // updateDissipation(this.temp).then(res => {
              //   if(res.code==200) {
              //     this.addSuccess(type)
              //   } else {
              //     res.message? this.$message.error(res.message):this.$message.error('修改失败')
              //   }
              // })
            }

          } else {
            return false;
          }
        });


      },
      //删除操作
      delFun () {
        if(this.unitItem.length==0) {
          this.$message({type: 'warning',message: '请选择节点'});
          return
        }

        this.$confirm(`是否删除该 ${this.unitItem.deviceClassificationName}?`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var params={
            id: this.unitItem.id
          }
          request({url: "/deviceClassification/delete",method: "delete",params}).then(res => {
            if(res.code==200) {
              this.findUnitInfoFun()
              this.$message({type: 'success',message: `删除 ${this.unitItem.deviceClassificationName} 成功!`});
            }
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },
      //移除能流图节点的关联设备
      device_Del () {
        // console.log("this.multipleSelection",this.multipleSelection);
        if(this.multipleSelection.length==0) {
          this.$message({type: 'warning',message: '请勾选需要删除的设备!'});
          return
        }
        var ids=""
        this.multipleSelection.forEach(item => ids+=','+item.virtualDeviceNo)


        var params={
          "noes": ids.slice(1),
          "id": this.unitItem.id
        }

        request({url: "/deviceClassification/deleteDeviceByClassification",method: "DELETE",params}).then(res => {
          console.log(res,'res');
          if(res.code==200) {
            this.$message({type: 'success',message: '移除成功!'});
            this.findUnitInfoFun();
            this.getDeviceList({id: this.unitItem.id})
          } else {
            this.$message({type: 'error',message: `移除失败,${res.message}`});
          }
        })
        // dissipationRemove(d).then(res => {
        //   if(res.code==200) {
        //     this.$message({type: 'success',message: '移除成功!'});
        //     this.getDeviceList({id: this.unitItem.id})
        //   } else {
        //     this.$message({type: 'error',message: `移除失败,${res.message}`});
        //   }
        // })

      },
      //树形结构选中节点
      currentChecked (nodeObj,SelectedObj) {
        var mycheckedNodes=SelectedObj.checkedNodes
        this.checkedNodes=mycheckedNodes.filter(item => item.Content.Category=='Device')
      },
      //添加能流图节点的关联设备
      device_Add () {
        //  console.log(this.nodeItem);
        if(!this.unitItem.id) {
          this.$message({type: 'warning',message: '请选择节点!'});
          return
        }
        if(this.checkedNodes.length==0) {
          this.$message({type: 'warning',message: '请勾选需要添加的设备!'});
          return
        }
        var devices=[]
        this.checkedNodes.forEach(item => {
          devices.push(item.Content.Id)
        })
        var params={
          "noes": devices.join(','),
          "id": this.unitItem.id
        }

        request({url: "/deviceClassification/saveDeviceByClassification",method: "post",params}).then(res => {
          console.log(res,'res');
          if(res.code==200) {
            this.checkedNodes=[];
            this.$refs.tree.setCheckedKeys([]);
            this.$message({type: 'success',message: '添加成功!'});
            this.findUnitInfoFun();
            this.getDeviceList({id: this.unitItem.id})
          } else {
            this.$message({type: 'error',message: `添加失败! ${res.message}`});
          }
        })
        // dissipationSave(d).then(res => {
        //   //  console.log("res添加设备",res);
        //   if(res.code==200) {
        //     this.$message({type: 'success',message: '添加成功!'});
        //     this.checkedNodes=[]
        //     this.$refs.tree.setCheckedKeys([]); 
        //   } else {
        //     this.$message({type: 'error',message: `添加失败! ${res.message}`});
        //   }
        // })



        // console.log("checkedNodes",this.checkedNodes);
        // console.log("12131",this.nodeItem);
      },
    },
  }
</script>

<style lang='scss' scoped>
  .energy-flow {
    width: 100%;
    padding: 8px;
  }

  .con {
    width: 100%;
    height: 100%;
    display: flex;
    box-sizing: border-box;
    overflow: hidden;

    .con-title {
      display: flex;
      align-items: center;
      font-size: 18px;
      margin-left: 10px;
      margin-top: 20px;

      img {
        width: 28px;
        height: 28px;
        margin-right: 10px;
      }
    }

    .tree-left {
      width: 3rem;
      height: 100%;
      padding: 20px 12px 12px 12px;
      box-sizing: border-box;
      background-color: #fff;
      margin-right: 8px;

      .btns {
        display: flex;
        // justify-content: space-evenly;
        margin-bottom: 8px;

        button {
          margin-right: 12px;
        }

        .el-button--mini {
          padding: 7px 10px !important;
        }

        .el-button+.el-button {
          margin-left: 0px;
        }
      }

      .search {
        display: flex;
        justify-content: center;
        margin-bottom: 12px;
      }

    }

    .content {
      // flex-grow: 1;
      width: calc(100% - 6rem);
      background-color: #fff;
      border-right: 1px solid #e6e6e6;

      .content-title {
        margin-left: 20px;
        margin-top: 20px;
        font-size: 16px;
        color: #999;
      }

      .mytable {
        width: 86.5%;
        margin: 20px 20px 0px 20px;


      }

      .conten-btns {
        margin-top: 200px;

        // button {
        //    margin-bottom: 20px;
        // }
        div {
          width: 0.88rem;
          height: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          border-radius: 2px;
          background-color: #409EFF;
          color: #fff;
          margin-bottom: 40px;
          cursor: pointer;

          img {
            width: 0.2rem;
            height: 0.2rem;
            margin-left: 0.1rem;
          }
        }

      }
    }

    .tree-right {
      width: 3rem;
      height: 100%;
      background-color: #fff;
      padding: 20px 12px 12px 20px;
      box-sizing: border-box;
    }
  }
</style>